import { Button, Typo } from "@pepperstone/pepper-ui-kit";

import { ModalContent } from "../../ModalContent";

type MobileStatusModalProps = {
  isVisible: boolean;
  close: () => void;
  status: string;
  statusDescription: string;
};

export const MobileStatusModal = ({
  isVisible,
  close,
  status,
  statusDescription,
}: MobileStatusModalProps) => {
  return (
    <ModalContent isVisible={isVisible} close={close}>
      <div className="flex flex-grow flex-col justify-between gap-4">
        <Typo
          elem="h1"
          size="xs"
          type="heading"
          textColor="ps-text-product-text-strong"
        >
          {status}
        </Typo>
        <Typo
          elem="p"
          size="xs"
          type="label"
          textColor="ps-text-text-primary-secondary"
        >
          {statusDescription}
        </Typo>
        <Button
          data-testid="ok-button"
          as="a"
          variant="ps-btn-primary"
          size="ps-btn-md"
          onClick={close}
        >
          OK
        </Button>
      </div>
    </ModalContent>
  );
};
